<template>
    <div>
        <!-- Cabecera -->
        <pm-header background="fondoInicio.png">
			<template slot="contenido">
				<div class="row h-50 justify-content-center  m-5">
					<div
						class="text-center text-lg-left text-white pl-lg-2 m-2"
						data-aos-delay="750">
					</div>

                    <div class="p-2 pt-5 bd-highlight align-self-center mx-1 mx-md-5">
                        <button id="btnDescargarCartaPorte"
                                @click="descargarCarta()"
                                class="btn btn-block text-white btn-blue-1"
                                type="button"
                        >Descargar carta porte</button>
                    </div>				
				</div>
			</template>
		</pm-header>
      
        <pm-pie-pagina></pm-pie-pagina>
    </div>
</template>

<script>
import PmHeader from "@/components/publica/Header"
import PmPiePagina from "@/components/publica/PiePagina"
import servicio from "@/services/servicio-publica"
import Swal from "sweetalert2"

export default {
    components:{
        PmHeader,
        PmPiePagina
    },
    data() {
        return {
            base: '',
            decode: '',
            toJson: '',
        }
    },
    async mounted() {

        this.base = this.$route.params.json

        this.decode = window.atob(this.base)

        this.toJson = JSON.parse(this.decode)

    },
    methods: {
        async descargarCarta(){

            var response = await servicio.descargarCartaPorte(this.toJson);

            if( response.value == true ){

                if ( response.data.pdfBase64 != "" ){
                    //Descargar pdf
                    await this.download(response.data.pdfBase64, response.data.nameFilePDF,  'data:application/pdf;base64,');
                    await Swal.fire({
                        text: "Se descargo correctamente el PDF",
                        icon: "success",
                    })
                }else{
                    await Swal.fire({
                        text: response.data.msgErrorPDF,
                        icon: "warning",
                    })
                }

                // if ( response.data.xmlBase64 != "" ){
                //     //Descargar xml
                //     await this.download(response.data.xmlBase64, response.data.nameFileXML,  'data:application/xml;base64,');
                //     await Swal.fire({
                //         text: "Se descargo correctamente el XML",
                //         icon: "success",
                //     })
                // }else{
                //     await Swal.fire({
                //         text: response.data.msgErrorXML,
                //         icon: "warning",
                //     })
                // }

            }else{
                await Swal.fire({
                    text: response.message,
                    icon: "warning",
                })
            }

        },

        async download(fromBase64, nameFile, tipo ){
            const downloadLink = document.createElement("a");
            const fileName = nameFile;
            
            downloadLink.href = tipo + fromBase64;
            downloadLink.download = fileName;
            downloadLink.click();
            document.body.appendChild(downloadLink);
        }
    },
}
</script>

<style scoped>

</style>